import { DURATION_UNIT } from 'src/features/membershipType/types';

enum UNIT_MILLISECONDS {
    HOUR = 60 * 60 * 1000,
    DAY = 24 * UNIT_MILLISECONDS.HOUR,
    WEEK = 7 * UNIT_MILLISECONDS.DAY,
    MONTH = 30 * UNIT_MILLISECONDS.DAY,
    YEAR = 365 * UNIT_MILLISECONDS.DAY,
}
export function getNormalizedDuration(ms: number) {
    let remainingMs = ms;

    const units = [
        { unit: DURATION_UNIT.YEAR, ms: UNIT_MILLISECONDS.YEAR },
        { unit: DURATION_UNIT.MONTH, ms: UNIT_MILLISECONDS.MONTH },
        { unit: DURATION_UNIT.WEEK, ms: UNIT_MILLISECONDS.WEEK },
        { unit: DURATION_UNIT.DAY, ms: UNIT_MILLISECONDS.DAY },
        { unit: DURATION_UNIT.HOUR, ms: UNIT_MILLISECONDS.HOUR },
    ];

    return units.reduce(
        (acc, { unit, ms }) => {
            const value = Math.floor(remainingMs / ms);
            if (value > 0) {
                acc.push({ value, unit });
                remainingMs -= value * ms;
            }
            return acc;
        },
        [] as { unit: DURATION_UNIT; value: number }[],
    );
}
